'use client';

import React from 'react';
import prefersReducedMotion from '@utils/prefersReducedMotion';

export default function HeroActions({ children }) {
  if (!children) return null;

  const handleClick = (e) => {
    const target = e.target.closest('a, button');
    if (!target) return;

    const href = target.getAttribute('href');

    const scrollToElementMiddle = (element) => {
      const targetPosition = element.getBoundingClientRect().top + window.scrollY;
      // Setting the offset slightly more to the top than center, vertically
      const offsetPosition = targetPosition - window.innerHeight / 4;
      window.scrollTo({
        top: offsetPosition,
        behavior: prefersReducedMotion() ? 'auto' : 'smooth'
      });
    };

    // Smooth scroll if href is an anchor on the same page
    if (href?.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) {
        e.preventDefault();
        scrollToElementMiddle(el);
        return;
      }
    }

    // Determine if it points to the current page (e.g., post.permalink used as a default)
    const isCurrentPage = target.href && new URL(target.href).pathname === window.location.pathname;

    if (!href || href === '#' || isCurrentPage) {
      e.preventDefault();

      const content = document.querySelector('[class*="__content"], .PostContent');
      if (content) {
        scrollToElementMiddle(content);
      } else {
        window.scrollBy({ top: window.innerHeight / 2, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
    }
  };

  return (
    <div className="Hero__actions" onClick={handleClick}>
      {children}
    </div>
  );
}
